import { createVNode as _createVNode } from "vue";
// Styles
import "./VMain.css";

// Composables
import { makeTagProps } from "../../composables/tag.mjs";
import { useLayout } from "../../composables/layout.mjs";
import { useSsrBoot } from "../../composables/ssrBoot.mjs"; // Utilities
import { genericComponent, useRender } from "../../util/index.mjs";
export const VMain = genericComponent()({
  name: 'VMain',
  props: {
    scrollable: Boolean,
    ...makeTagProps({
      tag: 'main'
    })
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      mainStyles
    } = useLayout();
    const {
      ssrBootStyles
    } = useSsrBoot();
    useRender(() => _createVNode(props.tag, {
      "class": ['v-main', {
        'v-main--scrollable': props.scrollable
      }],
      "style": [mainStyles.value, ssrBootStyles.value]
    }, {
      default: () => [props.scrollable ? _createVNode("div", {
        "class": "v-main__scroller"
      }, [slots.default?.()]) : slots.default?.()]
    }));
    return {};
  }
});
//# sourceMappingURL=VMain.mjs.map